import { FC } from 'react';
import styles from './Tab.styles.module.css';

export enum TabVariant {
  SPACED = 'SPACED',
  COMPACT = 'COMPACT',
}

interface TabProps {
  children: React.ReactNode;
  isActive?: boolean;
  onClick: () => void;
  ariaControls?: string;
  disabled?: boolean;
  variant?: TabVariant;
  customStyle?: string;
}

const variantClassesMap = {
  [TabVariant.SPACED]: styles.tab,
  [TabVariant.COMPACT]: `${styles.tab} ${styles['tab--compact']}`,
};

const Tab: FC<TabProps> = ({
  children,
  isActive = false,
  onClick,
  ariaControls,
  disabled,
  variant = TabVariant.SPACED,
  customStyle = '',
}) => {
  const variantClass = variantClassesMap[variant];

  return (
    <button
      role='tab'
      aria-selected={isActive}
      aria-disabled={disabled}
      type='button'
      onClick={onClick}
      className={`${variantClass} ${
        isActive ? styles['tab--active'] : ''
      } ${customStyle}`}
      aria-controls={ariaControls}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

Tab.displayName = 'Tab';
export default Tab;
